// ##############################
// // // NavPills component style
// #############################

import { roseColor, primaryColor, infoColor, successColor, warningColor, dangerColor } from 'assets/jss/material-dashboard-pro-react.jsx'

const classificaStyle = (theme) => ({
  active: {
    '&,&:hover': {
      color: primaryColor,
      backgroundColor: 'white',
      borderTopLeftRadius: '6px',
      borderTopRightRadius: '6px',
    },
  },
  displayNone: {
    display: 'none !important',
  },
  tabRoot: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  selectInput: {
    width: '160px',
    backgroundColor: 'white',
    padding: '8px',
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
  },
})

export default classificaStyle



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/components/classificaStyle.jsx